import { render, staticRenderFns } from "./form-allocations.vue?vue&type=template&id=ff6412cc&scoped=true"
import script from "./form-allocations.vue?vue&type=script&lang=js"
export * from "./form-allocations.vue?vue&type=script&lang=js"
import style0 from "./form-allocations.vue?vue&type=style&index=0&id=ff6412cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6412cc",
  null
  
)

export default component.exports